/**
 * Locale JSON for i18next — same registry as API (civic-champs-translations/locales/index.ts).
 */
import localeResources from 'civic-champs-translations/locales/index'

export const i18nResources = localeResources
